import React from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";

const SubscriptionPlans = () => {
  const plans = [
    {
      name: "Free",
      price: "$0",
      features: [
        "3 battles per month",
        "Basic character selection",
        "Standard battle types",
      ],
      current: false,
    },
    {
      name: "Premium",
      price: "$9.99",
      features: [
        "Unlimited battles",
        "Extended character selection",
        "Priority support",
        "All battle types",
      ],
      current: true,
    },
    {
      name: "Pro",
      price: "$19.99",
      features: [
        "All Premium features",
        "Custom character creation",
        "Advanced battle analytics",
        "API access",
      ],
      current: false,
    },
  ];

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Subscription Plans
        </Typography>
        <Grid container spacing={3}>
          {plans.map((plan) => (
            <Grid item xs={12} md={4} key={plan.name}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography
                    variant="h5"
                    component="div"
                    gutterBottom
                  >
                    {plan.name}
                  </Typography>
                  <Typography
                    variant="h3"
                    component="div"
                    gutterBottom
                  >
                    {plan.price}
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.secondary"
                    >
                      /month
                    </Typography>
                  </Typography>
                  <List>
                    {plan.features.map((feature) => (
                      <ListItem key={feature} dense>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={feature} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
                <CardActions>
                  <Button
                    fullWidth
                    variant={plan.current ? "outlined" : "contained"}
                    color={plan.current ? "success" : "primary"}
                    disabled={plan.current}
                  >
                    {plan.current ? "Current Plan" : "Upgrade"}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default SubscriptionPlans;
